import { getId } from '@/utils/temporaryHelper'

export const InitialTabId = getId()
